<template>
  <div class="wscn-http404-container">
    <div class="wscn-http404">
      <div class="bullshit">
        <img src="../assets/images/bg_task.png">
        <div class="bullshit__info">{{message}}</div>
        <!-- <el-button type="primary"
          size="medium"
          @click="reLogin2()"> 返 回 </el-button> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Page404',
  data() {
    return {
      message: '任务已过期或不存在',
    }
  },
  methods: {
    reLogin2() {
      this.$router.back(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.wscn-http404-container {
  transform: translate(-50%, -50%);
  position: absolute;
  top: 40%;
  left: 50%;
}
.wscn-http404 {
  position: relative;
  width: 1200px;
  padding: 0 50px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .bullshit {
    position: relative;
    padding: 30px 0;
    overflow: hidden;
    text-align: center;
    img {
      height: 200px;
      width: auto;
    }
    .bullshit__info {
      color: #606266;
      margin-top: 15px;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../vue-common-laboratory/src/layout/NoMessage.vue